import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
const uuidSchema = z.string().uuid('Invalid UUID format');
// ─── Param schemas ───────────────────────────────────────────────────────────
export const CourseVersionParamsSchema = z.object({
    courseId: uuidSchema,
    versionId: uuidSchema,
});
// ─── Response types ──────────────────────────────────────────────────────────
export const CourseVersionStatusSchema = z.enum([
    'draft',
    'in_review',
    'changes_requested',
    'approved',
    'published',
    'discarded',
]);
export const CourseVersionSchema = z
    .object({
    id: uuidSchema,
    courseId: uuidSchema,
    version: z.number(),
    status: CourseVersionStatusSchema,
    title: z.string(),
    description: z.string(),
    iconUrl: z.string().nullable(),
    headerImageUrl: z.string().nullable(),
    accentColour: z.string().nullable(),
    progressionType: z.string().nullable(),
    createdBy: uuidSchema,
    createdAt: z.string(),
    updatedAt: z.string(),
    submittedBy: uuidSchema.nullable(),
    submittedAt: z.string().nullable(),
    reviewedBy: uuidSchema.nullable(),
    reviewedAt: z.string().nullable(),
    reviewNotes: z.string().nullable(),
    publishedBy: uuidSchema.nullable(),
    publishedAt: z.string().nullable(),
    publishNotes: z.string().nullable(),
})
    .openapi('CourseVersion');
export const CourseVersionModuleSchema = z.object({
    id: uuidSchema,
    sourceModuleId: uuidSchema.nullable(),
    position: z.number(),
    title: z.string(),
    description: z.string(),
    topics: z.array(z.object({
        id: uuidSchema,
        sourceTopicId: uuidSchema.nullable(),
        position: z.number(),
        title: z.string(),
        description: z.string(),
        lessons: z.array(z.object({
            id: uuidSchema,
            sourceLessonId: uuidSchema.nullable(),
            position: z.number(),
            baseLessonVersionId: uuidSchema.nullable(),
            title: z.string(),
        })),
    })),
});
export const CourseVersionWithStructureSchema = CourseVersionSchema.extend({
    modules: z.array(CourseVersionModuleSchema),
});
// ─── Input schemas ───────────────────────────────────────────────────────────
export const CreateCourseVersionSchema = z
    .object({
    publishNotes: z.string().max(500).optional(),
})
    .openapi('CreateCourseVersion');
export const DiscardCourseVersionSchema = z
    .object({
    reason: z.string().max(500).optional(),
})
    .openapi('DiscardCourseVersion');
// ─── Query schemas ───────────────────────────────────────────────────────────
export const ListCourseVersionsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=course-version.schema.js.map